import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/billing/subscription', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
